import { render, staticRenderFns } from "./AddNonTransferablesModal.vue?vue&type=template&id=2142ee3f&"
import script from "./AddNonTransferablesModal.vue?vue&type=script&lang=ts&"
export * from "./AddNonTransferablesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports